import React from "react";
import styled, { css } from "styled-components";
import { useTranslation } from "react-i18next";
import { Label } from "components/bootstrap";
import { getRepositoryTypeLabel } from "./types";
const RepositoryInfo = styled.div`
  min-width: 0;
`;
const RepositoryLabel = styled(Label)(
  ({ theme }) => css`
    margin-left: ${theme.spacings.xs};
  `
);
const RepositoryDescription = styled.p(
  ({ theme, $isSelected }) => css`
    margin-bottom: 0;
    margin-top: ${theme.spacings.xs};
    font-size: ${theme.fonts.size.small};
    color: ${$isSelected ? theme.colors.variant.lightest.gray : theme.colors.variant.darker.gray};
  `
);
const STATUS_PRESENTATION = {
  ready: { labelKey: "status_cell.labels.ready", bsStyle: "success" },
  not_ready: { labelKey: "status_cell.labels.not_ready", bsStyle: "danger" },
  missing_credentials: { labelKey: "status_cell.labels.missing_credentials", bsStyle: "warning" },
  invalid_credentials: { labelKey: "status_cell.labels.invalid_credentials", bsStyle: "warning" },
  unknown: { labelKey: "status_cell.labels.unknown", bsStyle: "default" }
};
const RepositoryOption = ({ repository, isSelected }) => {
  var _a, _b, _c;
  const { t } = useTranslation("enterprise_data_tiering");
  const status = (_b = STATUS_PRESENTATION[(_a = repository.status) != null ? _a : repository.ready ? "ready" : "not_ready"]) != null ? _b : STATUS_PRESENTATION.unknown;
  return /* @__PURE__ */ React.createElement(RepositoryInfo, null, repository.label, /* @__PURE__ */ React.createElement(RepositoryLabel, null, getRepositoryTypeLabel((_c = repository.provider) != null ? _c : repository.type)), /* @__PURE__ */ React.createElement(RepositoryLabel, { bsStyle: status.bsStyle }, t(status.labelKey)), repository.description && /* @__PURE__ */ React.createElement(RepositoryDescription, { $isSelected: isSelected }, repository.description));
};
export default RepositoryOption;
